import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BookingView.html?raw';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import { TiEntities, TiInterfaces } from "./TiTypes";
import TiBookingSummary from './BookingSummary';
import TiBookingForm from './BookingForm';
import TiMainRouteView from './Route/MainRouteView';
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import TiTransportGoodManager from './TransportGoodsManager';
import TiTransportRouteView from './Route/TransportRouteView';
import { ToasterHelpers } from "../../more/Helpers";

class TiBookingView extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private sectionBookingForm: HTMLElement;
    private sectionSummary: HTMLElement;
    private sectionRouteSections: HTMLElement;

    private mainRouteView: MdsLax<InstanceType<typeof TiMainRouteView>>;
    private bookingSummary: MdsLax<InstanceType<typeof TiBookingSummary>>;
    private bookingForm: MdsLax<InstanceType<typeof TiBookingForm>>;

    private transportGoodsExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private summaryExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private routeSectionsExpander: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionTransportGoods: HTMLElement;
    private transportGoodsContainer: HTMLElement;
    private transportGoodsManager: MdsLax<InstanceType<typeof TiTransportGoodManager>>;

    private sectionTransportRoutes: HTMLElement;
    private transportRoutesContainer: HTMLElement;
   

    private data: TiEntities.BookingEntityData;
    private entityID: string = null;

    private _requestHandle: dojo.request.Promise<any>;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private settings: TiInterfaces.TiBookingViewSettings = null;


    setup(entityID: string,
        settings: TiInterfaces.TiBookingViewSettings,
        entityData?: TiEntities.BookingEntityData
        ) {
        if (!entityID) return;

        let dlg = new GenericDialog();
        this.dlg = dlg;

        dlg.show(this,
            this.translate("General_Loading"),
            null, null,
            "close",
            lang.hitch(this, this._onDlgCallback)
        );

        dlg.setCloseOnEscape(true);

        this.settings = settings;

        if (entityData && entityData.ID == entityID) {
            this._onLoadItemDataResponse(entityData);
        } else {
            this.loadItemData(entityID);
        }
    }

    private loadItemData(entityID?: string) {
        
        if(entityID) this.entityID = entityID;

        if (!this.entityID) return;

        this.StandbyStart();

        let data = { "bookingID": this.entityID };

        this._requestHandle = this.RequestManager.callfunction(
            "Webtool_API_TransportIntermodal__LoadBooking",
            data,
            lang.hitch(this, this._onLoadItemDataResponse),
            lang.hitch(this, this._onLoadItemDataError),
            false // sync
        );
    }

    private _onLoadItemDataError(error: more.requestErrorMessage) {
        this.StandbyStop();

        this.emit("loaded");

        alert(error.Message);
    }

    private _onLoadItemDataResponse(data: TiEntities.BookingEntityData) {
        this.StandbyStop();

        this.emit("loaded");

        this.setData(data);
    }

    private setData(data: TiEntities.BookingEntityData) {

        let dlg = this.dlg;

        this.data = data;

        // data enthält mehr als für die jewilige Typisierung nötig, geht daher für beides. 
        // DAS IST DUMM, eigentlich.
        //let entityData = <TiEntities.BookingEntityData>data;

        dlg._setHeaderAttr(data.displayname);

        let settings = this.settings;

        

        if (settings?.showSummary != false) {
            this.hideNode(this.sectionSummary, false);

            let summary = new TiBookingSummary();
            this.bookingSummary = summary;
            summary.placeAt(this.sectionSummary, "only");
            summary.setData(data);

            if (settings.showSummary != "noExpander") {
                this.summaryExpander = new ExpandableSection();
                this.summaryExpander.attachAtNode(summary.domNode);

                this.summaryExpander.setHeading(this.translate("General_Label_Summary"));

                if (settings.showSummary == "expand") {
                    this.summaryExpander.toggleExpand(true);
                }
                if (this.data.warnings?.length) {
                    this.summaryExpander.setMarking(ExpandableSectionMarkings.warning)
                }
            }


        } else {
            this.hideNode(this.sectionSummary);
            this.UiModder.domConstruct.empty(this.sectionSummary);
        }


        if (settings?.showTransportGoods != false) {
            this.hideNode(this.sectionTransportGoods, !data?.transportGoods?.length);

            this.transportGoodsManager.reset();
            

            if (!this.transportGoodsExpander && settings?.showTransportGoods != "noExpander") {
                this.transportGoodsExpander = new ExpandableSection();
                this.transportGoodsExpander.attachAtNode(this.transportGoodsContainer);

                this.transportGoodsExpander.setHeading(this.translate("TiBooking__TransportGoods"));

                if (settings?.showTransportGoods == "expand") {
                    this.transportGoodsExpander.toggleExpand(true);
                }
            }

            this.transportGoodsManager.setupFromBooking(this.data);

            if (settings.transportGoodsConfig) {
                this.transportGoodsManager.setReadonly(settings.transportGoodsConfig.interactive !== true);
                this.transportGoodsManager.enableFreightOccupation(settings.transportGoodsConfig.showFreightOccupation === true);
            }

        } else {

            this.hideNode(this.sectionTransportGoods, !data?.transportGoods?.length);
        }
        if (data.transportGood) {

        }

        if (this.hasUserRole("TI_wizard") && settings?.showBookingFormConfirmation == true) {
            this.hideNode(this.sectionBookingForm, false);

            let bookingForm = new TiBookingForm;
            
            bookingForm.placeAt(this.sectionBookingForm, "only");
            bookingForm.gotoBookingConfirmation(data, false);
            

            on(bookingForm, "bookingCancelled", lang.hitch(this, this._onBookingUpdated));
            on(bookingForm, "bookingConfirmed", lang.hitch(this, this._onBookingUpdated));
            on(bookingForm, "bookingUpdated", lang.hitch(this, this._onBookingUpdated));

            if (data.is_contains_reserved_section_timeslot == true) {
                dlg.addButton("confirmReservedSectionSlot",
                    this.translations["TiBooking__BtnConfirmReservedSectionSlots"],
                    lang.hitch(this, this.confirmReservedSectionSlots),
                    null,
                    "cD1",
                    "fa-regular fa-calendar-check",
                    false,
                    "left first");
            }
        } else {
            this.UiModder.domConstruct.empty(this.sectionBookingForm);
            this.hideNode(this.sectionBookingForm);
        }

         
        if (settings?.showMainRoute != false) {

            this.hideNode(this.sectionRouteSections, false);

            this.mainRouteView = new TiMainRouteView();
            this.mainRouteView.placeAt(this.sectionRouteSections, "only");

            if (settings?.showMainRoute != "noExpander") {
                this.routeSectionsExpander = new ExpandableSection();
                this.routeSectionsExpander.attachAtNode(this.mainRouteView.domNode);

                this.routeSectionsExpander.setHeading(this.translate("Ti_Label_RouteOverview"));

                if (settings?.showMainRoute == "expand") {
                    this.summaryExpander.toggleExpand(true);
                }
            }

            if (this.data?.is_cancelled) {
                // bei stornierten Einträgen keine Änderung des Bookingstatus zulassen
                if (settings?.mainRouteViewConfig?.sectionsConfig?.enableBookingStatus == "interactive") {
                    settings.mainRouteViewConfig.sectionsConfig.enableBookingStatus = true;
                }
            }

            this.mainRouteView.setConfig(settings.mainRouteViewConfig);

            this.mainRouteView.setBooking(data);

            this.mainRouteView.on("change", lang.hitch(this, this._onChange_MainRouteView));
        } else {
            this.hideNode(this.sectionRouteSections);
            this.UiModder.domConstruct.empty(this.sectionRouteSections);
        }

        if (settings.showTransportRoute != false && data.transportGood?.ref_transport_route) {
            this.hideNode(this.sectionTransportRoutes, false);
            
            this.UiModder.domConstruct.empty(this.transportRoutesContainer);

            let list = [data.transportGood.ref_transport_route];
            for (let route of list) {
                let routeView = new TiTransportRouteView();
                routeView.placeAt(this.transportRoutesContainer);

                routeView.setData(route, {

                });

                if (settings.showTransportRoute != "noExpander") {
                    let exp = new ExpandableSection();
                    exp.placeAt(this.transportGoodsContainer);

                    exp.setup(routeView.domNode, this.createFontawesomeIcon("fas fa-route", "&nbsp;").outerHTML + this.translate("Ti_Label_TransportRoute"));

                    if (settings.showTransportRoute == "expand") {
                        exp.toggleExpand(true);
                    }

                } else {
                    
                }
            }
        }
    }

    private _onChange_MainRouteView() {
        this.emit("change", this.entityID);
    }

    private confirmReservedSectionSlots() {

        this.StandbyStart();

        let url = window.appRoot + "TransportIntermodal/ConfirmReservedSectionSlots";

        let data = { "bookingID": this.entityID };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onConfirmReservedSectionSlotsResponse),
            lang.hitch(this, this._onConfirmReservedSectionSlotsError),
            false // sync
        );
    }

    private _onConfirmReservedSectionSlotsResponse(response) {
        this.StandbyStop()

        this.loadItemData();
    }

    private _onConfirmReservedSectionSlotsError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.showToast({
            title: "Error",
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message,
            options: {
                closeButton: true
            }
        });
    }


    private _onDlgCallback(result: number) {
        if (this._requestHandle) {
            if (result <= 0) {
                this._requestHandle.cancel();
            }
        }
    }

    private _onBookingUpdated() {
        this.loadItemData();
        this.emit("change", this.entityID);
    }

    private _onChange_TgManager() {
        this.data.transportGoods = this.transportGoodsManager.getTransportGoods();

        this.bookingSummary.setData(this.data);
    }
    private _onSaving_TgManager() {
        
    }
    private _onSaved_TgManager() {
        //this.bookingSummary.setData(this.data);
        this._onBookingUpdated();
    }
    private _onExceeded_TgManager(isExceeded: boolean) {
        if (this.transportGoodsExpander) {
            this.transportGoodsExpander.setMarking(isExceeded ? ExpandableSectionMarkings.warning : ExpandableSectionMarkings.default)
        }
    }


    postCreate(): void {
        this.RequestManager.handleAs = "jsonWithDate";
        super.postCreate.apply(this, arguments as any);


        this.transportGoodsManager.on("change", lang.hitch(this, this._onChange_TgManager));
        this.transportGoodsManager.on("saving", lang.hitch(this, this._onSaving_TgManager));
        this.transportGoodsManager.on("saved", lang.hitch(this, this._onSaved_TgManager));
        this.transportGoodsManager.on("exceeded", lang.hitch(this, this._onExceeded_TgManager));

    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(TiBookingView);